import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { niceDate } from '../util/date';

import "./Home.css"

function Instance (props){
    
    useEffect(() => {     
    }, []); 

    return (        
        <div className='pt-2'>           
            <h1>Instance</h1>
            <div className="ag-theme-alpine" >
                config.auth.clientId: {props.instance?.config.auth?.clientId}<br></br>
                config.auth.authority: {props.instance?.config.auth?.authority}<br></br>
                config.auth.redirectUri: {props.instance?.config.auth?.redirectUri}<br></br>
                config.auth.postLogoutRedirectUri: {props.instance?.config.auth?.postLogoutRedirectUri}<br></br>   
            </div>
        </div>                
    )
}

export default Instance;